import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { getClasses } from "../lib/requestFunctions";

export function useClasses() {
    const [selectedClass, setSelectedClass] = useState<string | undefined>(
        undefined,
    );

    const classes = useQuery({ queryKey: ["classes"], queryFn: getClasses });

    const classesData = classes.data?.result.map((cls) => ({
        key: cls.id,
        text: cls.name,
    })) ?? []

    return {
        selectedClass,
        setSelectedClass,
        classesData,
        classesLoading: classes.isPending,
        classesError: classes.isError,
    }

}